export default function($) {
  var trigger = $('.js-search-form-trigger'),
      search_form = $('.js-search-form'),
      is_open = false;

  trigger.on('click', function() {
    is_open = !is_open;
    $(this).toggleClass('!fill-primary');
    search_form.slideToggle();
    if( is_open ) {
      search_form.find('input').focus();
    }
  })
}
